import { logAnalyticsEvent } from './analytics';

export const uploadWithPresignedUrl = async (url: string, file: File) => {
  try {
    const presignedUrlResponse = await fetch(url, {
      method: 'PUT',
      body: file,
    });

    return presignedUrlResponse.url.split('?')[0];
  } catch {
    logAnalyticsEvent({
      category: 'error',
      action: 'uploadWithPresignedUrlError',
    });
  }
};
